// @flow
import React from "react";
import Banner from "../components/generic/banner";
import { TextSection } from "../components/generic/text";

import LinkTiles from "../components/home/linkTiles";
import PathBlurb from "../components/home/pathBlurb";
import CustomersAndAwards from "../components/generic/customersAndAwards";

const story = {
  heading: "The Path Story",
  copy: [
    `Arising out of necessity and utility, the innovation at the core of Path began first as an answer to the question of the possibility of truly granular network intelligence.
    This innovation, a distributed network monitoring platform, was a necessary one, as Founder and CTO Marshal Webb can attest.
    Frustrated due to the lack of granular & insightful network intelligence services and curious of the promise of novel approaches to this central problem, Mr. Webb began work on the foundation of the platform with a number of close friends.
    This foundational phase would indeed prove to be quite fruitful, with new concepts such as incentivized network and geographic diversity being melded into the framework of the platform.`,

    `Before long however, it would become readily apparent that this approach had incredible promise, and in turn had quite a lot of work to be done.
    With the project requiring significant amounts of development and engineering prowess, alongside an in-depth understanding of the still nascent network security industry, the Path Founder also went with a novel approach to hiring and assembling the staff.
    Being aware of the wealth of niche knowledge that a select few of those on the differing sides of network security possessed, Mr. Webb assembled a who’s-who team of cyber security professionals, security researchers, and network engineers to help build the Path platform.`,

    `This variation in background knowledge has allowed the development of the platform to exceed expectations with regards to its functionality, web panel design, and structural stability.
    Additions such as path visualization, interaction testing, and performance monitoring have brought the platform to the bleeding edge in terms of technical capabilities, pushing Path even further beyond the traditional network monitoring platforms and services.
    Would you expect otherwise from a group of professionals this talented and well-acquainted with network security research?`,
  ],
};

const AboutUs = () => (
  <main>
    <Banner
      heading="Power in numbers"
      caption={[
        `With our performance monitoring tools, together we revolutionize the effort in helping make the internet a better & safer place for everyone.`,
      ]}
    />
    <TextSection heading={story.heading} copy={story.copy} />

    <CustomersAndAwards />
    <LinkTiles />
  </main>
);

export default AboutUs;



// WEBPACK FOOTER //
// ./src/pages/about-us.js